import React from 'react';
import useMembershipQuote from '../../../hooks/params/useMembershipQuote';
import { CotizadorPlanesModal } from './CotizadorPlanesModal';
import { QuoteIcon } from './icons';
import './CotizadorPlanes.scss';

/**
 * FloatingCotizadorPlanes
 * ---------------------------------------------------------------------------
 * Botón flotante gemelo de la Calculadora BCV. Abre el cotizador de planes
 * de membresía (misma lógica de precio que /new-membership).
 */
export const FloatingCotizadorPlanes = () => {
  const quote = useMembershipQuote();

  return (
    <>
      <button
        type="button"
        className="cotizador-fab"
        onClick={quote.openModal}
        aria-label="Abrir cotizador de planes"
        title="Cotizador de planes"
      >
        <QuoteIcon />
      </button>

      <CotizadorPlanesModal quote={quote} />
    </>
  );
};

export default FloatingCotizadorPlanes;
